import { useQuery } from '@tanstack/react-query';
import { fetchNotifications, fetchUnreadNotificationCount } from './request';
import { notificationKeys } from './key';

export const useNotifications = (page?: number) => {
  return useQuery({
    queryKey: notificationKeys.list(page),
    queryFn: () => fetchNotifications(page),
    retry: false,
  });
};

export const useUnreadNotificationCount = () => {
  return useQuery({
    queryKey: notificationKeys.unreadCount(),
    queryFn: fetchUnreadNotificationCount,
    retry: false,
  });
};
